import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Toolbar from "src/components/Toolbar";
import { useHistory } from "react-router-dom";
import Otp from 'src/components/Otp';
import policySt, { PolicyStore } from 'src/stores/PolicyStore';
import { observer } from 'mobx-react-lite';
import UserInfoService from "src/utils/UserInfoService";
import { OTP_TYPES, OTP_LENGTH, OTP_TIME } from "src/constants";

interface OtpCancelPolicyObserverProps {
  policyStore?: PolicyStore;
}

const OtpCancelPolicyObserver = observer(({ policyStore }: OtpCancelPolicyObserverProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [errOtp, setErrOtp] = useState("");
  const [remainTime, setRemainTime] = useState(OTP_TIME);

  useEffect(() => {
    let intervalId = setInterval(() => {
      if (remainTime > 0) {
        setRemainTime(remainTime - 1);
      } else {
        clearInterval(intervalId);
      }
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [remainTime]);

  const _handleOk = (otp) => {
    if (!otp || otp.length < OTP_LENGTH) {
      setErrOtp(t("otp_include_6_digit"));
      return;
    }
    policyStore?.cancelPolicy({
      params: {
        ...policyStore?.infoReasonCancel,
        verificationOtp: {
          requestId: policyStore?.verificationOtp?.requestId,
          otp: otp,
        }
      },
      history
    }).catch(error => {
      setErrOtp(error);
    });
  };

  const _handleResend = async () => {
    let result = await policyStore?._createOtp({ type: OTP_TYPES.CANCEL_POLICY, policyNumber: policyStore?.policyToCancel?.policyNum});
    if(result){
      setErrOtp("");
      setRemainTime(OTP_TIME);
    }
  };

  const _handleClose = () => {
    history.push("/");
  };

  const _handleBack = () => {
    history.goBack();
  };

  return (
    <div className="screen-container bg-primary">
      <Toolbar
        title={t('otp_toolbar')}
        showClose={true}
        onClose={_handleClose}
        onBack={_handleBack}
      />
      <Otp 
        onOk={_handleOk}
        onResend={_handleResend}
        phone={UserInfoService.getUserInfo()?.mobile || ''}
        errOtp={errOtp}
        remainTime={remainTime}
        inputOtpHint={
          t('input_otp_hint_1', {
            phone: UserInfoService.getUserInfo()?.mobile || '',
            policyNum: policyStore?.policyToCancel?.policyNum || '',
            assuredName: policyStore?.policyToCancel?.assuredName || '',
          })
        } 
      />
    </div>
  );
});

const OtpCancelPolicy = () => <OtpCancelPolicyObserver policyStore={policySt} />;
export default OtpCancelPolicy;
